import * as ActionType from "./verifiedUserPlan.type";

const initialState = {
  verifiedUserPlanData: [],
};

export const verifiedUserPlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_VERIFIED_USER_PLAN:
      return {
        ...state,
        verifiedUserPlanData: action.payload,
      };
    case ActionType.ADD_VERIFIED_USER_PLAN:
      let data = [...state.verifiedUserPlanData];
      data.unshift(action.payload);
      return {
        ...state,
        verifiedUserPlanData: data,
      };
    case ActionType.UPDATE_VERIFIED_USER_PLAN:
      return {
        ...state,
        verifiedUserPlanData: state.verifiedUserPlanData.map((updatePlan) =>
          updatePlan._id === action.payload.id ? action.payload.editPlan : updatePlan
        ),
      };
    case ActionType.ACTIVE_VERIFIED_USER_PLAN:
      const { planId, planActiveData } = action.payload;
      const updatedPlanSwitch = state.verifiedUserPlanData?.map((item) => {
        if (item?._id === planId) {
          return {
            ...item,
            isActive: planActiveData.isActive,
          };
        }
        return item;
      });
      return {
        ...state,
        verifiedUserPlanData: updatedPlanSwitch,
      };
    case ActionType.DELETE_VERIFIED_USER_PLAN:
      return {
        ...state,
        verifiedUserPlanData: state.verifiedUserPlanData.filter(
          (data) => data._id !== action.payload
        ),
      };
    default:
      return state;
  }
};
